import { useState, useEffect } from "react";

import { apiRoot } from "../constants";

const useDishes = () => {
  const [dishes, setDishes] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch(`${apiRoot}/dishes/`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setLoading(false);
      });
  }, []);

  return {
    dishes,
    error,
    loading,
  };
};

export default useDishes;
